import Vue from 'vue'
import Router from 'vue-router'
import Personal from './personal'

Vue.use(Router)

let RouteList = [{
    path: '/',
    component: resolve => require(['@/views/layout/App.vue'], resolve),
    meta: {
        title: '首页',
        keepAlive: false,
    },
    children: [{
        path: '/personal',
        name: 'personal',
        meta: {
            title: '个人中心',
            keepAlive: true
        },
        component: resolve => require(['@/views/personal/Index.vue'], resolve),
    },
    {
        path: '/',
        name: 'Dashboard',
        meta: {
            title: '首页',
            keepAlive: true
        },
        component: resolve => require(['@/views/home/Index.vue'], resolve),
    },

    // 接单大厅
    {
        path: '/hall',
        name: 'hall',
        meta: {
            title: '接单大厅',
            keepAlive: false
        },
        component: resolve => require(['@/views/hall/hall.vue'], resolve),
    },
    // 竞价订单
    {
        path: '/mine_hall',
        name: 'mine_hall',
        meta: {
            title: '竞价订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/hall/mine_hall.vue'], resolve),
    },
    // 我的订单
    {
        path: '/all_orders',
        name: 'all_orders',
        meta: {
            title: '我的订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/all_orders.vue'], resolve),
    },

    // 接单设置
    // {
    //     path: '/receive_set',
    //     name: 'receive_set',
    //     meta: {
    //         title: '接单设置',
    //         keepAlive: false
    //     },
    //     component: resolve => require(['@/views/set/receive_set.vue'], resolve),
    // },
    // 自动报价
    {
        path: '/auto_menu',
        name: 'auto_set',
        meta: {
            title: '自动报价',
            keepAlive: false,
        },
        component: resolve => require(['@/views/set/auto_menu.vue'], resolve),
    },
    // 自主接单
    {
        path: '/self_menu',
        name: 'self_set',
        meta: {
            title: '自主接单',
            keepAlive: false,
        },
        component: resolve => require(['@/views/set/self_menu.vue'], resolve),
    },
    // 承包接单
    {
        path: '/subscribe_menu',
        name: 'subscribe_set',
        meta: {
            title: '承包接单',
            keepAlive: false,
        },
        component: resolve => require(['@/views/set/subscribe_menu.vue'], resolve),
    },
    // 兜底接单
    {
        path: '/pocket_menu',
        name: 'pocket_set',
        meta: {
            title: '兜底接单',
            keepAlive: false,
        },
        component: resolve => require(['@/views/set/pocket_menu.vue'], resolve),
    },
    //自动报价规则
    {
        path: '/auto_set',
        name: 'auto_set',
        meta: {
            title: '自动报价规则',
            keepAlive: false
        },
        component: resolve => require(['@/views/set/auto_set.vue'], resolve),
    },
    //自主接单规则
    {
        path: '/self_set',
        name: 'self_set',
        meta: {
            title: '自主接单规则',
            keepAlive: false
        },
        component: resolve => require(['@/views/set/self_set.vue'], resolve),
    },
    //承包接单规则
    {
        path: '/subscribe_set',
        name: 'subscribe_set',
        meta: {
            title: '承包接单规则',
            keepAlive: false
        },
        component: resolve => require(['@/views/set/subscribe_set.vue'], resolve),
    },
    //兜底接单规则
    {
        path: '/pocket_set',
        name: 'pocket_set',
        meta: {
            title: '承包接单规则',
            keepAlive: false
        },
        component: resolve => require(['@/views/set/pocket_set.vue'], resolve),
    },
    // 结算中金额
    {
        path: '/settling_amount',
        name: 'settling_amount',
        meta: {
            title: '结算中金额',
            keepAlive: false
        },
        component: resolve => require(['@/views/personal/settling_amount.vue'], resolve),
    },

    // 冻结中金额
    {
        path: '/lock_amount',
        name: 'lock_amount',
        meta: {
            title: '结算中金额',
            keepAlive: false
        },
        component: resolve => require(['@/views/personal/lock_amount.vue'], resolve),
    },

    // 我的资金明细
    {
        path: '/mine_account',
        name: 'mine_account',
        meta: {
            title: '我的资金明细',
            keepAlive: false
        },
        component: resolve => require(['@/views/personal/account.vue'], resolve),
    },

    // 我的资金明细
    {
        path: '/balance_amount',
        name: 'balance_amount',
        meta: {
            title: '我的余额明细',
            keepAlive: false
        },
        component: resolve => require(['@/views/personal/money_record.vue'], resolve),
    },

    // 竞价订单详情
    {
        path: '/hall_detail',
        name: 'hall_detail',
        meta: {
            title: '竞价详情',
            keepAlive: false
        },
        component: resolve => require(['@/views/hall/hall_detail.vue'], resolve),
    },
    // 我的报价详情
    {
        path: '/mine_hall_detail',
        name: 'mine_hall_detail',
        meta: {
            title: '我的报价详情',
            keepAlive: false
        },
        component: resolve => require(['@/views/hall/mine_hall_detail.vue'], resolve),
    },

    // 我的出单详情
    {
        path: '/push_ticket',
        name: 'push_ticket',
        meta: {
            title: '我的报价详情',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/push_ticket.vue'], resolve),
    },
    // 活动
    {
        path: '/act',
        name: 'act',
        meta: {
            title: '活动',
            keepAlive: false
        },
        component: resolve => require(['@/views/act/act.vue'], resolve),
    },
    // 活动详情
    {
        path: '/act_detail',
        name: 'act_detail',
        meta: {
            title: '活动详情',
            keepAlive: false
        },
        component: resolve => require(['@/views/act/act_detail.vue'], resolve),
    },
    // 邀请活动详情
    {
        path: '/act_activity',
        name: 'act_activity',
        meta: {
            title: '邀请活动详情',
            keepAlive: false
        },
        component: resolve => require(['@/views/act/act_activity.vue'], resolve),
    },
    // 邀请奖励
    {
        path: '/invitation',
        name: 'invitation',
        meta: {
            title: '邀请奖励',
            keepAlive: false
        },
        component: resolve => require(['@/views/invitation/invitation.vue'], resolve),
    },
    {
        path: '/notice',
        name: 'notice',
        meta: {
            title: '通知公告',
            keepAlive: false
        },
        component: resolve => require(['@/views/notice/notice.vue'], resolve)
    },
    {
        path: '/notice_detail',
        name: 'notice_detail',
        meta: {
            title: '通知公告详情',
            keepAlive: false
        },
        component: resolve => require(['@/views/notice/notice_detail.vue'], resolve)
    },
    {
        path: '/integral',
        name: 'integral',
        meta: {
            title: '积分规则',
            keepAlive: false
        },
        component: resolve => require(['@/views/integral/integral.vue'], resolve)
    },{
        path: '/detailed',
        name: 'detailed',
        meta: {
            title: '积分明细',
            keepAlive: false
        },
        component: resolve => require(['@/views/integral/detailed.vue'], resolve)
    },{
        path: '/screen',
        name: 'screen',
        meta: {
            title: '筛选',
            keepAlive: false
        },
        component: resolve => require(['@/views/hall/screen.vue'], resolve)
    },
    {
        path: '/screen_menu',
        name: 'screen_menu',
        meta: {
            title: '订单筛选',
            keepAlive: false
        },
        component: resolve => require(['@/views/set/screen_menu.vue'], resolve)
    },{
        path: '/screen_set',
        name: 'screen_set',
        meta: {
            title: '筛选规则编辑',
            keepAlive: false
        },
        component: resolve => require(['@/views/set/screen_set.vue'], resolve)
    },
    ]
},
{
    path: '/login',
    name: 'Login',
    meta: {
        title: '登录',
        keepAlive: false
    },
    components: {
        blank: resolve => require(['@/views/login/Login.vue'], resolve),
    }
},
{
    path: '/*',
    name: 'NotFound',
    meta: {
        title: '404',
        keepAlive: true
    },
    components: {
        blank: resolve => require(['@/views/error/404.vue'], resolve),
    }
}
]

export default new Router({
    routes: RouteList
})